import axios from 'axios'
import { genURL } from "../../_getjson";

export default async function checkexpenses(code) {
    let rs = ""
    if (code) {
        let url = "CSEXPENSE/GETCODE?Codes=" + code
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 5000 }).then((res) => {
            if (res.data.length > 0) {
                rs =  res.data[0].MYNAMETH
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    return rs
};